import { HttpClient } from '@shared/adapters/HttpClient';
import { ApiResponse } from '@shared/models';
import type { LocationStockBatchRef } from '../utils/locationBatchCompatibility';

// 🎯 Interfaz para el tipo de ubicación
export interface LocationType {
  id: number;
  name: string;
}

// 🎯 Interfaz para el producto asociado a la ubicación
export interface LocationProduct {
  id: number;
  name: string;
  image: string;
  code: string;
}

// 🎯 Interfaz para la respuesta de ubicación
export interface LocationResponse {
  id: number;
  team_id: number;
  code: string;
  type_id: number;
  type: LocationType;
  is_locked: boolean;
  product_id: number | null;
  product: LocationProduct | null;
  deleted_at: string | null;
  stock: number;
  stock_batches?: LocationStockBatchRef[];
  stock_location_carts: any[];
  created_at: string;
  aisle_id: number | null;
}

// 🎯 Interfaz para la respuesta paginada de la API
export interface LocationsApiResponse {
  data: LocationResponse[];
  meta: {
    total: number;
    perPage: number;
    currentPage: number;
    lastPage: number;
  };
  links: {
    first: string;
    prev: string | null;
    next: string | null;
    last: string;
  };
}

// 🎯 Adaptador para el endpoint de ubicaciones
export class LocationsApiAdapter {
  constructor(private httpClient: HttpClient) {}

  // 🎯 Obtener ubicación por código usando search
  async getLocationByCode(code: string): Promise<ApiResponse<LocationResponse>> {
    try {
      const response = await this.httpClient.get<LocationsApiResponse>(`/locations`, { search: code });

      const normalizedCode = code.trim().toLowerCase();
      const exactMatch = response.data?.find((location) => location.code?.trim().toLowerCase() === normalizedCode);

      if (exactMatch) {
        return {
          success: true,
          data: exactMatch,
          message: 'Ubicación encontrada',
        };
      } else {
        return {
          success: false,
          data: null,
          message: 'La ubicación no existe',
        };
      }
    } catch (error: any) {
      return {
        success: false,
        data: null,
        message: error.response?.data?.message || 'Error al buscar la ubicación',
      };
    }
  }
}
